import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgxModalDraggableDirective } from '../../../directives/draggable.directive';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LeadTask } from '../../../types/lead.type';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { LeadsService } from '../../../modules/leads/services/leads.service';
import { Preset } from '../../../types/preset.type';
import { debounceTime } from 'rxjs/operators';
import { SubscribeLeadResult } from '../../../types/lead_subscribe.type';
import { ToursService } from '../../../services/tours.service';

@Component({
  selector: 'app-leads-scan-tasks-edit-modal',
  templateUrl: './leads-scan-tasks-edit-modal.component.html',
  styleUrls: ['./leads-scan-tasks-edit-modal.component.scss']
})
export class LeadsScanTasksEditModalComponent implements OnInit, OnDestroy {
  public modalDirective: NgxModalDraggableDirective;
  public leadTask: LeadTask;
  public copy = false;
  private readonly destroy$ = new Subject<void>();
  type: 'create' | 'subscribe' = 'create';
  public type$: BehaviorSubject<'create' | 'subscribe'> = new BehaviorSubject('create');
  public subscribeComplete$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public subscribeCompleteResult: SubscribeLeadResult;
  helpTypeAdd = '';
  helpTypeSubscribe = '';
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  get title(): string {
    if (this.copy) {
      return 'Копирование задания';
    }
    if (this.leadTask?.id) {
      return 'Изменение задания';
    }
    return 'Задание на сканирование';
  }
  constructor(
    private toursService: ToursService,
    public leadsService: LeadsService,
    public bsModalRef: BsModalRef,
  ) {
  }

  ngOnInit(): void {
    if (this.copy) {
      this.leadTask.id = undefined;
    }
    this.leadsService.createTaskFromPreset$
      .pipe(takeUntil(this.destroy$), debounceTime(10))
      .subscribe((preset: Preset) => {
      this.type = 'create';
      this.type$.next('create');
    });

    if (!this.toursService.tourLeadTaskNotShow) {
      this.toursService.startLeadTaskTour$.next(3000);
    }
  }
  close(): void {
    this.bsModalRef.hide();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  subscribeComplete(result: SubscribeLeadResult) {
    this.subscribeComplete$.next(true);
    this.subscribeCompleteResult = result;
  }
}
